export enum WindowHapiEventCommandName {
	/* State */
	stateHydrate = "state:hydrate",
	stateInitialHydrate = "state:hydrate-initial",
	stateSubscribe = "state:subscribe",
	stateSnapshotSave = "state:snapshot-save",
	stateSnapshotRestore = "state:snapshot-restore",
	stateSnapshotClean = "state:snapshot-clean",

	/* Service */
	serviceLoad = "service:load",
	serviceInit = "service:init",
	serviceRequest = "service:request",
	serviceStart = "service:start",
	serviceSuccess = "service:success",
	serviceFailure = "service:failure",
	serviceFinish = "service:finish",

	/* Config */
	configSetPartnerToken = "config:partnerToken", // used for impersonation purposes
	configSetAreLogsEnabled = "config:areLogsEnabled",
	configSetWalletCurrency = "config:setWalletCurrency",

	/* API */
	apiRequest = "api:request",

	/* Routing */
	routingRequest = "routing:request",

	/* QA */
	qaRequest = "qa:request",

	/* DOM */
	iframeLoaded = "dom:iframe-loaded",
	iframeUnloaded = "dom:iframe-unloaded",
	domAppendChild = "dom:append-child",
	domElementEvent = "dom:element-event",
	domRemoveChild = "dom:remove-child",
	domHideElement = "dom:hide-element",
	domHideElements = "dom:hide-elements",
	domShowElement = "dom:show-element",
	domShowElements = "dom:show-elements",
	domSetStyleAttribute = "dom:set-style-attribute",
	domSetStyleAttributes = "dom:set-style-attributes",
	domSetAttribute = "dom:set-attribute",
	domSetAttributes = "dom:set-attributes",
	domAddClass = "dom:add-class",
	domAddClasses = "dom:add-classes",
	domRemoveClass = "dom:remove-class",
	domRemoveClasses = "dom:remove-classes",
	domSetStyle = "dom:set-style",
	domSetStyles = "dom:set-styles",
	domAddStyleSheet = "dom:add-stylesheet",
	domRemoveStyleSheet = "dom:remove-stylesheet",
	domSlotAvailable = "dom:slot-available",
	domElementMounted = "dom:element-mounted",
	domElementUnmounted = "dom:element-unmounted",
	domChangeIcons = "dom:change-icons",
	domScrollTo = "dom:scroll-to",
	domGetScroll = "dom:get-scroll",
	domEventTriggered = "dom:dom-event-triggered",

	/* Location */
	locationSetHref = "location:href",
}

export enum EventCommandErrorResponse {
	stateNotFound = "state-undefined-or-not-found",
}
